import { useRef, useEffect, useState } from 'react'
import Hls from 'hls.js'
import './VideoPlayer.css'

function VideoPlayer({ streamUrl, directUrl, title, onClose }) {
  const videoRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [useHls, setUseHls] = useState(true)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    let hls = null

    const initPlayer = () => {
      if (useHls && streamUrl) {
        if (Hls.isSupported()) {
          hls = new Hls({
            maxLoadingDelay: 4,
            maxBufferLength: 30,
            maxBufferSize: 60 * 1000 * 1000,
          })
          
          hls.loadSource(streamUrl)
          hls.attachMedia(video)
          
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            setIsLoading(false)
            video.play().catch(() => {})
          })
          
          hls.on(Hls.Events.ERROR, (event, data) => {
            if (data.fatal) {
              console.error('HLS error:', data)
              // Try direct stream as fallback
              if (directUrl) {
                setUseHls(false)
              } else {
                setError('Error al cargar el video')
              }
            }
          })
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Native HLS support (Safari)
          video.src = streamUrl
          video.addEventListener('loadedmetadata', () => {
            setIsLoading(false)
            video.play().catch(() => {})
          })
        }
      } else if (directUrl) {
        // Try direct stream
        video.src = directUrl
        video.addEventListener('loadedmetadata', () => {
          setIsLoading(false)
          video.play().catch(() => {})
        })
        video.addEventListener('error', () => {
          setError('Error al cargar el video. Es posible que el formato no sea compatible.')
        })
      }
    }

    initPlayer()

    return () => {
      if (hls) {
        hls.destroy()
      }
    }
  }, [streamUrl, directUrl, useHls])

  // Handle keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  return (
    <div className="video-player-overlay" onClick={onClose}>
      <div className="video-player-container" onClick={(e) => e.stopPropagation()}>
        <div className="video-player-header">
          <h3>{title}</h3>
          <button className="video-player-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="video-player-wrapper">
          {isLoading && !error && (
            <div className="video-player-loading">
              <div className="spinner"></div>
              <p>Cargando video...</p>
            </div>
          )}
          
          {error && (
            <div className="video-player-error">
              <p>❌ {error}</p>
              <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
            </div>
          )}
          
          <video
            ref={videoRef}
            className="video-player"
            controls
            playsInline
            style={{ display: error ? 'none' : 'block' }}
          />
        </div>
      </div>
    </div>
  )
}

export default VideoPlayer
